import React, { useEffect, useState, Fragment} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container, Row, Col, Form, Button} from 'react-bootstrap'
import {useFormik} from 'formik'
import { validationSchemas } from '../../common/validation-Schemas-descargas'
import { obtenerResponsables, obtenerDescargasPrevias, generarDescarga, obtenerCriteriosFechaFiltro, obtenerCriteriosFecha} from '../../store/actions/descarga-casos-action'
import { Auth, LoadingComponent } from 'recupero-comunes'

const FiltrosDescarga = () => {
    const [loading, setLoading]=useState(false)
    const data_descargas = useSelector((state) => state.descargaCasosReducer)
    const { cfg_formInf, tiposDescarga, criteriosFecha, respuestaGenerar} = data_descargas
    const {rutUsuario, rutOrganizacion}=Auth.currentUser()
    const dispatch = useDispatch()
    const [isFechas, setIsfechas]=useState(false)

    const [responsables, setResponsables] = useState([]);

    useEffect(() => {
        
        const roles = ['0070COBRAEXT', '0070ABOEXT', '70ABOEXSOAS', '70PRSIPACIA'];

        const fetchUsuariosPorRol = async () => {
            const resultados = await Promise.all(
                roles.map(async (rol) => {
                    const query = Buffer.from(
                    JSON.stringify({ idOrganizacion: rutOrganizacion, rol, tipoPersona: '0080PROVE00' })).toString('base64');
                    const response = await dispatch(obtenerResponsables(query));
                    const data = response.payload || [];
                    console.log("rol - data:", rol, data);
                    // Agrega el rol al usuario para luego agrupar
                    return data.map((u) => ({ ...u, roles: [rol] }));
                })
            );
            const todos = resultados.flat();
            // Agrupar por ID de usuario
            const mapa = new Map();

            todos.forEach((usuario) => {
                if (!mapa.has(usuario.id)) {
                    mapa.set(usuario.id, { ...usuario });
                } else {
                    const existente = mapa.get(usuario.id);
                    existente.roles = [...new Set([...existente.roles, ...usuario.roles])];
                }
            });

            // Formatear y ordenar
            const formateados = Array.from(mapa.values())
                .map((u) => ({
                    nombre: `${u.nombre} - ${u.roles.join(', ')}`,
                    id: u.id,
                }))
                .sort((a, b) => a.nombre.localeCompare(b.nombre));

            setResponsables(formateados);
        };

        fetchUsuariosPorRol();
    }, [rutOrganizacion]);

    const formik = useFormik({
        initialValues: {
          "rutcia": '',
          "rutusr":'',
          "tipoDescarga": '',
          "responsable": '',
          "fechadesde": '',
          "fechahasta": '', 
          "criterioFecha": '',
          "judicializar": ''
        },
        validationSchema: validationSchemas(isFechas),
        onSubmit: (formData) => {
            setLoading(true)
            const dataForm = {};

            dataForm['rutcia'] = rutOrganizacion && rutOrganizacion
            dataForm['rutusr'] = rutUsuario && rutUsuario     
            dataForm['tipoInforme'] = formData.tipoDescarga ? {id: formData.tipoDescarga, glosa: tiposDescarga.find(element => element.id == formData.tipoDescarga).nombre} : {};       
            dataForm['responsable'] = formData.responsable ? {id: formData.responsable, glosa: responsables.find(element => element.id == formData.responsable).nombre} : {};
            dataForm['fechadesde'] = formData.fechadesde;
            dataForm['fechahasta'] = formData.fechahasta;
            dataForm['criteriosFecha'] = formData.criterioFecha ? {id: formData.criterioFecha, glosa: criteriosFecha.find(element => element.id == formData.criterioFecha).nombre} : {};       
            dataForm['judicializar'] = formData.judicializar;
            console.log("dataForm: ", dataForm);
            try {
                dispatch(generarDescarga(dataForm))
                .then(() => {
                    let query = Buffer.from(JSON.stringify({'rutcia': rutOrganizacion && rutOrganizacion, 'rutusr': rutUsuario && rutUsuario})).toString('base64')  
                    dispatch(obtenerDescargasPrevias(query));
                })
                .then(()=>setLoading(false))
            } catch (error) {
                setLoading(false)
                console.log("error: ", error);
            }

        }
    })
    useEffect(() => {
        let excel = respuestaGenerar && respuestaGenerar.respuestaGenerar.object;
        console.log("excel: ", excel);
        if (excel) {

            setLoading(false);
            
            var link = document.createElement("a");
            link.download = excel.filename;
            link.href = "data:" + excel.mimetype + ";base64," + excel.xlsxfile;
            link.click();
        }

    }, [respuestaGenerar]);

    const handleLimpliar=()=>{
        formik.resetForm();
        setIsfechas(false);
    }

    /**
     * RG-536 fallback del Criterio por Fecha.
     * Los criterios salen de cfg_filtro_informes (299002 / 288002), pero no todos los tipos de
     * descarga están configurados: "Siniestro sin Calificar" no tiene filas y el combo quedaba
     * vacío, cuando antes del ticket mostraba todos los del concepto 305.
     * Si la configuración no devuelve opciones se recarga el catálogo completo, así el tipo sin
     * configurar sigue usable y el día que se configure empieza a respetarla sin tocar código.
     * El `Array.isArray` no es cosmético: el backend devuelve `0` en vez de `[]` cuando no hay datos.
     */
    const cargaCriteriosSiNoHayConfig = (opciones) => {
        if (!Array.isArray(opciones) || opciones.length === 0) {
            let query = Buffer.from(JSON.stringify({concepto: 305})).toString('base64')
            dispatch(obtenerCriteriosFecha(query))
        }
    }
    return (      
    <>
      <style type='text/css'>
        {`
        .btn-limpiar {
            background-color: #F0AD3E;
            color: #FFFFFF;
            width: 140px;
            
        }
        .btn-buscar {
            background-color: #C14B49;
            color: #FFFFFF;
            width: 140px;
            padding:6px 0px 6px 0px;
      
          }
        `}
        </style>
        <LoadingComponent show={loading}/>
        <Form onSubmit={formik.handleSubmit}>
        <Container>
            <Container>            
            {cfg_formInf? (
                <div >                  
                    <Row >                 
                        <Col md='4'>
                            <Form.Label className='mb-2 mt-2'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf ? cfg_formInf.cfg_formInf['descarga-casos-filtro-tipo-descarga'] : "Tipo Descarga"}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                className='mt-2'
                                aria-label='Default select example'
                                onChange={(e) => {
                                    formik.handleChange(e)
                                    //RG-536 el Criterio por Fecha depende del Tipo de Descarga
                                    formik.setFieldValue('criterioFecha', '')
                                    if (e.target.value) {
                                        //299002 Descarga de Siniestros · 288002 Criterio Fecha
                                        let query = Buffer.from(JSON.stringify({ tipoInforme: e.target.value, idFiltro:288002, idFuncionFiltro:299002})).toString('base64')
                                        dispatch(obtenerCriteriosFechaFiltro(query))
                                            .then((res) => cargaCriteriosSiNoHayConfig(res && res.payload))
                                            .catch(() => cargaCriteriosSiNoHayConfig(null))
                                    }
                                }}
                                name='tipoDescarga'
                                value={(formik.values.tipoDescarga)}
                                error={formik.errors.tipoDescarga}
                            >
                            <option value={''}>Seleccione...</option>
                            {tiposDescarga &&
                                tiposDescarga?.filter(c => c.agrupacion == 292003)
                                    .map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.tipoDescarga ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.tipoDescarga}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>                      
                        <Col md='5'>
                            <Form.Label className='mb-2 mt-2'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['descarga-casos-filtro-responsable']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                className='mt-2'
                                aria-label='Default select example'
                                onChange={(e) => {
                                    formik.handleChange(e)

                                }}
                                name='responsable'
                                value={(formik.values.responsable)}
                                error={formik.errors.responsable}
                            >
                            <option value={''}>Seleccione...</option>
                            {responsables &&
                                responsables?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.responsable ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.responsable}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                        <Col md='3'>
                            <Form.Check 
                                type='checkbox'
                                id='judicializar'
                                name='judicializar'
                                checked={Boolean(formik.values.judicializar)}                    
                                label={cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['descarga-casos-filtro-judicializar'] || 'Clasificado para Judicializar'}
                                style={{marginTop:'60px'}}
                                onChange={e=>{                        
                                    formik.handleChange(e)                      
                                }}
                                value={formik.values.judicializar}
                            />
                        </Col>
                    </Row>
                    <Row >
                        <Col md='2'>
                            <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['descarga-casos-filtro-fecha-desde']}
                            </Form.Label>{' '}
                            <br />                   
                            <Form.Control type='date'
                                name='fechadesde'
                                value={formik.values.fechadesde}
                                onChange={(e)=>{
                                    formik.handleChange(e)     
                                    setIsfechas(true);  
                                }}
                            ></Form.Control>                
                        </Col>
                        <Col md='2' >
                            <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['descarga-casos-filtro-fecha-hasta']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Control type='date'
                                name='fechahasta'
                                value={formik.values.fechahasta}
                                onChange={(e)=>{
                                    formik.handleChange(e)
                                    setIsfechas(true);  
                                }}
                            ></Form.Control>
                        </Col>
                        <Col md='3'>
                            <Form.Label className='mb-2 mt-4'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['descarga-casos-filtro-criterio-fecha']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                onChange={(e) => {
                                    formik.handleChange(e)
                                    setIsfechas(true);  
                                }}
                                name='criterioFecha'
                                value={(formik.values.criterioFecha)}
                                error={formik.errors.criterioFecha}
                            >
                            <option value={''}>Seleccione...</option>
                            {criteriosFecha && criteriosFecha
                                ?.filter(p => (p.agrupacion == 0 || p.agrupacion == tipoGestion))
                                ?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.criterioFecha ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.criterioFecha}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                    </Row>
                    <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                    <Row className='mt-2'>                            
                        <Col className='d-flex align-items-end justify-content-end m-2'>
                            <Button className='m-2' variant='limpiar' onClick={handleLimpliar}  >
                                {cfg_formInf.cfg_formInf ? cfg_formInf.cfg_formInf["descarga-casos-filtro-btn-limpiar"] : "Limpiar"}
                            </Button>
                            <Button className='m-2' variant='buscar' type='onSubmit' >
                                {cfg_formInf.cfg_formInf ? cfg_formInf.cfg_formInf["descarga-casos-filtro-btn-gen-informe"] : "Generar Informe"}
                            </Button>                            
                        </Col>
                    </Row>
                </div>
            ) : ""}
            </Container>
        </Container>
        </Form>
    </>
  )
}
export default FiltrosDescarga 